// Format value for <input type"dateime-local">
export function formatDatetimeLocal(value) {
    if (!value) return "";
    const date = new Date(value);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
}

// Format value (UTC) for backend
export function formatForBackend(value) {
    return value ? new Date(value).toISOString() : null;
}